<template>
  <div>
    <Navigation />
    <section class="section__container top__container blog__details">
      

      <div class="section__container center__text">
      <h1 class="title">Boostez vos événements avec le Vote par SMS</h1>
      </div>
      <h2>Organisez aisément un vote par SMS depuis votre ordinateur</h2>

      <p>Pour profiter de notre solution de vote par SMS, contactez-nous. 
        Une fois votre compte créé, vous pourrez accéder à notre plateforme 
        en ligne intuitive et conviviale. Animer vos événements deviendra un jeu d'enfant.</p>

        <h2>Adaptez votre système de vote par SMS à votre événement</h2>
      <p>
        Avant votre événement, maîtrisez l'outil de vote par SMS. Explorez les fonctionnalités
        de personnalisation de la plateforme telles que l'intégration d'images, la gestion des participants,
        la définition de délais, les mots-clés personnalisables... Vous pouvez même tester le système de vote avec vos équipes !
      </p>
      <h2>Animez votre événement avec notre système de vote par SMS</h2>
      <p>
        Vos invités participent en envoyant par SMS le mot-clé du vote suivi du numéro de leur choix au 43365. 
        Vous avez le contrôle total, de l'affichage en direct des votes à la clôture du vote, pour vous aider 
        dans l'animation de votre événement.
      </p>
      
      <h2>Accédez aux résultats et statistiques du vote</h2>
      <p>
        Évaluez l'impact de votre animation et l'engagement de vos visiteurs en consultant les statistiques détaillées
        du vote sur la plateforme. Obtenez des informations précises sur le nombre de votes par participant et organisez
        facilement un tirage au sort en fin de soirée.
      </p>

      <h2>Faites de votre événement un moment mémorable à votre image</h2>
      <p>
        Notre solution de vote par SMS dynamise vos réunions, concours, élections, salons, etc. Optez pour un mot-clé
        personnalisé, intégrez votre logo et concevez un événement sur mesure à votre image.
      </p>
      <h2>Engagez votre public sans effort ni équipement</h2>
      <p>
        Pas besoin de plus qu'un téléphone et des SMS ! Impliquez vos invités en les invitant à voter lors de vos événements 
        en envoyant un SMS à un numéro court non surtaxé - aucune connexion Internet nécessaire.
      </p>
      <h2>Animez votre événement avec interactivité et dynamisme</h2>
      <p>
        Impliquez votre public en l'invitant à valider son vote par SMS, garantissant ainsi le succès de vos événements. 
        Encouragez leur participation active à l'élection en les captant aisément.
      </p>
    </section>
    <section class="section__detail center__text">
      <p>Pour toute question concernant l'utilisation du vote par SMS,<br/> n'hésitez pas à nous contacter</p>
       <div class="btn__wrapper">
       <router-link class="btn" to="/contact"
              >CONTACTEZ-NOUS</router-link
            > 
       </div>
  </section>
   <div>
   <p class="disponable">*Prochainement à votre disposition.</p>
   </div>
    <Footer/>
  </div>
</template>

<script>
import Navigation from "./Navigation";
import Footer from "./Footer";
export default {
  components: {
    Navigation,
    Footer,
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/base.scss';
.section__detail{
    background: $color-tertiary;
    padding: 4rem;
    width: 55%;
    margin: 0 auto;
    color:$color-white;
    
}
.connect__btn{
    padding: 1rem;
    border: none;
    color: $color-white;
    background: $color-secondary;
    border-radius: 5px;
    font-weight: bold;
     cursor: pointer;
     text-align: center;

}
.disponable{
  padding-left: 1rem;
  font-weight: bold;
}
@media(min-width:64rem){
.top__container{
  margin-top:10rem;
 }
    .section__detail{
        font-size: 1.2rem;
        font-weight: bold;
    }
    .btn__wrapper{
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .disponable{
      margin-left: 13rem;
    }
}
</style>
